import {
  type ExportListParams,
  type ExportListResponse,
  listExports,
} from '@/lib/api/reports-client.js';
import { useQuery } from '@tanstack/react-query';

export const EXPORTS_LIST_QUERY_KEY = 'exports-list';

export function useExportsList(params: ExportListParams = {}) {
  return useQuery<ExportListResponse, Error>({
    queryKey: [EXPORTS_LIST_QUERY_KEY, params],
    queryFn: () => listExports(params),
    staleTime: 10_000,
    refetchOnWindowFocus: false,
  });
}
